import type { AosFaction } from "./factions";

export const Nighthaunt: AosFaction = {};
